import { Box, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { LoginBG } from "../../assets/png";
import { HaityLogo } from "../../assets/svg";

export const LoginPanel = () => {
  const { t } = useTranslation("common");
  const isTablet = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  if (isTablet) {
    return null;
  }
  return (
    <Box
      className="p-20 w-full flex-1"
      style={{ backgroundImage: `url(${LoginBG})` }}
    >
      <div className="text-center my-50">
        <img alt="mosan_logo" src={HaityLogo} />
      </div>
      <Typography className="mb-10">{t("loginContent.content_1")}</Typography>
      <Typography>{t("loginContent.content_2")}</Typography>
    </Box>
  );
};
